// extracted by mini-css-extract-plugin
export default {"wrapper":"EditorHeader_wrapper__U0iRg","root":"EditorHeader_root__f4w42","closeButton":"EditorHeader_closeButton__1EYr8"};